export const TermsConditionsData = [
  {
    listName: "About Pamo",
    list: [
      {
        item: "Pamo is a buyer-led marketplace that facilitates the sale, purchase, and delivery of all kinds of goods other than perishable goods. When a buyer requests to purchase an item and the merchant fulfills the request, a sale of a good contract is created.",
      },
      {
        item: "For the avoidance of doubt, all transactions entered into on the App are between the merchants and buyers and not between Pamo and the Users. While we may help facilitate the resolution of disputes between Users, Pamo has no control over and does not guarantee: the existence, quality, safety, or legality of items advertised; the truth or accuracy of Users' content or listings; the ability of merchants to sell items; the ability of buyers to pay for items; or that a buyer or merchant will complete a transaction or return an item.",
      },
    ],
  },
  {
    listName: "User Representations And Warranties",
    list: [
      {
        item: "By creating an account and using the Pamo platform you confirm that you accept these Terms. You also represent and warrant that: ",
      },
      {
        item: "You are of sound mind",
      },
      {
        item: "You are 18 years or older; or",
      },
      {
        item: "You are 13 or older but younger than 18, and your parent or legal guardian has reviewed these Terms on your behalf, understands and consents to, the terms and conditions herein contained.If you are a parent or guardian permitting a minor to use these Services, you agree to (i) supervise the minor's use of these Services; (ii) assume all risk associated with the minor's use of the Services; (iii) assume any liability resulting from the minor's use of the Services; (iv) ensure the accuracy and truthfulness of all information submitted by the minor and (v) assume responsibility and be bound by these Terms for the minor's access and use of these Services. ",
      },
      {
        item: "You will not make a post to request something illegal/ prohibited.",
      },
      {
        item: "You will not respond to a post that is demanding prohibited goods",
      },
      {
        item: "All information you supplied about your identity and location is true",
      },
      {
        item: "You will use this Service subject to the applicable laws and regulations, etc.",
      },
      {
        item: "You will notify Pamo of any unauthorized access to your account",
      },
      {
        item: "You will not make posts that infringe on another person's rights or interests, including any intellectual property rights or any other personal or proprietary rights of any third party.",
      },
    ],
  },
  {
    listName: "Account Registration",
    list: [
      {
        item: "Only registered Users may buy or sell items on Pamo.",
      },
      {
        item: "A registered User may function as a buyer in one circumstance and as a merchant in another as the case may be.",
      },
      {
        item: "To register as a User, you must provide a unique username (which is your phone number in this case), a pin code (which functions as your password), an email address, an identification card number as well as any other information Pamo may require.   Additionally, merchants will be required to provide business registration documents to obtain a Pamo verification badge. You will need your unique username and password to access Pamo to make a post, make a purchase, or sell an item. ",
      },
      {
        item: `You agree and warrant that your username and password shall:
	•	be used for personal use only; and 
	•	not be disclosed by you to any third party`,
      },
      {
        item: "You must link a valid payment method to your registered account.These payment methods may include but are not limited to mobile money and bank card details. ",
      },
      {
        item: "You may be asked to provide your location at the time of registration. Your location details shall be necessary to facilitate the delivery of items you purchase among others. There are 2 categories of users i.e. merchants and buyers,  ",
      },
      {
        item: "Buyers are users who can post items for purchase on the Trade Feed or buy from uploaded items on the Store.",
      },
      {
        item: "Merchants are individuals or businesses who can respond to a buyer's post with items for sale or upload products to the Pamo Store.",
      },
      {
        item: "A merchant may obtain a verification badge from Pamo.",
      },
      {
        item: `A verified merchant can respond to buyers’ posts with items from their inventory or upload products to the Store. Verified merchants receive notifications from Pamo whenever a post is made for an item, they have available in their inventory.  To obtain a verification badge, the merchant shall   supply Pamo with the following documents:
	•	Business Incorporation documents
	•	Current permit to operate in their industry (where necessary)
	•	Any other licenses/approvals required from the business `,
      },
      {
        item: "Pamo reserves the right, at its sole discretion, to reject a request for verification of a merchant on the App without the obligation to justify its decision. Pamo’s decisions on verification or otherwise of a merchant shall be final, and Pamo shall have exclusive authority to solve all disputes arising in connection with such requests for verification.",
      },
    ],
  },
  {
    listName: "How The Service Works",
    list: [
      {
        item: "Pamo allows Users to create and publish requests for items they wish to buy ('posts'), to view posts published by other users, to view items published to the Pamo Store, to respond to purchase requests made, and to communicate with other users on the app.",
      },
      {
        item: "A registered User can be a buyer or merchant at different points. Such a User shall operate from different accounts in different capacities.",
      },
      {
        item: "Users who want to purchase an item may make a post containing the specifications of the item.Such specifications may include but are not limited ",
      },
      {
        item: "The price they would like to pay for the item.",
      },
      {
        item: "A photograph of the item (optional) ",
      },
      {
        item: "Detailed description of the item e.g., color, size, shape, etc.",
      },
      {
        item: "Once a post is live, verified merchants looking to sell the items requested in the post will be notified by Pamo.",
      },
      {
        item: "For Buyers who want to buy from the Pamo store (“the Store”) they can view and select items uploaded by Merchants on the Store. They can select the (“I want this”) button on their screen and continue to make a purchase. The Pamo store is a feature that allows Merchants to list their products for all buyers to view and make purchases. ",
      },
      {
        item: "Once the item is uploaded to the Pamo Store, it becomes available for viewing by all buyers. Pamo will notify potential buyers who have shown interest in similar items. ",
      },
      {
        item: `For both cases, a deal is reached once the buyer and merchant accept each other's terms and agree to transact. The buyer will make the payment of the final agreed amount through Pamo. Pamo will hold the money in escrow and guarantee to the merchant that the buyer can pay the negotiated amount.`,
      },
      {
        item: "Pamo will hold the money in escrow and guarantee to the merchant that the buyer can pay the negotiated amount.",
      },
      {
        item: "Upon receipt of the item, the buyer will confirm the receipt of the item on the Pamo platform, and the merchant may also confirm delivery of the item. Pamo will then release the funds to the merchant.",
      },
      {
        item: "If the buyer fails to confirm receipt of the item but the merchant confirms delivery, the funds will be released to the merchant within 48 hours of the confirmation.",
      },
    ],
  },
  {
    listName: "Communications On The App",
    list: [
      {
        item: "Communication between users on the app is done through the Chatroom feature, by using the chatroom , you agree to use it responsibly. You agree that any files shared through the chatroom must not contain malicious software, viruses, or harmful content and must comply with applicable laws and standards.",
      },
      {
        item: "The Company shall not be liable for any damage or loss resulting from files shared through the chatroom. We recommend using caution when downloading or opening files received from other users.",
      },
      {
        item: "User Reporting: If you encounter content or behavior in the chatroom that you believe violates these Terms, you may report the user. Pamo may investigate reported incidents and take appropriate action, which may include but is not limited to warning users, removing content, or suspending accounts.",
      },
      {
        item: "Limitation of Liability for Chatroom Use: Pamo shall be not liable for any direct, indirect, incidental, or consequential damages resulting from the use of the chatroom feature, including, but not limited to, loss of data, unauthorized access, or misunderstandings arising from chat communications. Use of the chatroom is at your own risk, and you agree to indemnify Pamo from any claims related to your chatroom activity.",
      },
    ],
  },
  {
    listName: "Consent To Receive Communications",
    list: [
      {
        item: "By using the Pamo app, users consent to receive targeted push notifications, emails, and SMS alerts.These communications aim to provide you with relevant information, special offers, updates, or reminders based on your preferences and usage patterns.",
      },
      {
        item: "You can manage your communication preferences through the app’s settings. Opting out of certain notifications may limit your access to some features or updates on account activities ",
      },
      {
        item: "You may opt out of receiving targeted communications at any time. To do so, adjust your notification preferences in the app settings.",
      },
      {
        item: "Pamo shall not be liable for any direct, indirect, or consequential losses that arise as a result of your notification preferences",
      },
    ],
  },
  {
    listName: "Fees And Taxes",
    list: [
      {
        item: "Use of the Pamo platform is free.",
      },
      {
        item: "We rely on third-party card processors and payment service providers to facilitate the topping up of a trade card. These providers may charge users for use of their service on the platform.",
      },
      {
        item: "Payment for the items purchased and payment services accepted by Pamo are disclosed on the platform.",
      },
    ],
  },
  {
    listName: "Posting Conditions",
    list: [
      {
        item: "Merchants on Pamo will not be allowed to post their items on the Trade Feed until a request for the items they sell is posted.Merchant can however upload items from their inventory to the Store. At this point, Merchants may send responses to the specific user who made the post or requested to buy from the Store.",
      },
      {
        item: "Only buyers may make posts about the goods they need on the Trade Feed to be connected to merchants who have those items for sale.",
      },
      {
        item: "A buyer may cancel a post if no deal is reached. If a buyer makes payment, and a merchant decides to cancel the deal, the amount paid by the merchant shall be refunded. Once a merchant accepts an offer, a buyer cannot pull out. A buyer may only rescind an offer at any time before a merchant accepts.",
      },
      {
        item: `The following are prohibited on the Pamo App. Any post that: Contains nudity, Is Abusive, offensive, or harmful, Contains advertisement, Has an Illegal product, Has an image that does not match the product's description, Is suspicious or has stolen items, Has an unrealistic price and is considered inappropriate`,
      },
    ],
  },
  {
    listName: "Reported Posts",
    list: [
      {
        item: "Users can report posts that are offensive or sensitive. Reported posts are reviewed by the Pamo team and removed if they are found to violate our posting conditions. The Pamo team also reviews and removes posts that violate our posting conditions. Users who continually violate our posting conditions may be banned from using the app.",
      },
    ],
  },
  {
    listName: "Purchase Conditions",
    list: [
      { item: "When buying an item on our Services, you agree that: " },
      {
        item: "It is your responsibility to read the full item listing before committing to buy.",
      },
      {
        item: "You enter into a legally binding contract to purchase an item when you commit to buying an item or agree to a deal with a merchant/business.",
      },
      {
        item: "Not all users are vetted by Pamo before registration as such all deals reached between you and merchants/businesses are reached at the sole risk of the parties.",
      },
      {
        item: "Pamo does not guarantee the quality of goods bought using the Service.",
      },
    ],
  },
  {
    listName: "Trade Card",
    list: [
      {
        item: "We shall provide you with a closed-loop virtual trade card ('your trade card') when you register with us. You may transfer funds to your trade card via any of the payment channels listed on Pamo. You may only purchase goods on Pamo using your trade card. You shall fund your trade card with an amount not less than the amount you intend to purchase an item with and your delivery cost before you close a deal with a potential merchant for such an item.  You shall only be charged a transaction fee and statutory fees (where applicable) for the transfer of the funds from your wallet to your Trade Card. There are no associated charges when a user wants to withdraw from the Trade Card. ",
      },
    ],
  },
  {
    listName: "Payment",
    list: [
      {
        item: "There are no paid subscriptions on the app. The app only facilitates purchases/sales between anyone looking to buy a particular physical item and anyone who has the item for sale or uploaded the item to the Pamo Store.",
      },
    ],
  },
  {
    listName: "Escrow",
    list: [
      {
        item: "Users agree to an escrow agreement between Pamo and Users when they use the Pamo platform.",
      },
      {
        item: "Users authorize Pamo to hold funds paid by a buyer for a period and to release them to the merchant upon confirmation of receipt of goods by the buyer.",
      },
      {
        item: "When Users make payment on Pamo, it will be held in escrow until delivery of the purchased item has been confirmed by the buyer within forty-eight (48) hours of receipt of the goods.",
      },
      {
        item: "Once the item is received and the buyer confirms on the Apps, Pamo will allow the money to be sent to the merchant. The funds shall be released onto the Trade Card of the merchant.",
      },
      {
        item: "Any dispute arising between users concerning this escrow will be resolved per the terms of the Pamo Dispute Resolution Policy.",
      },
    ],
  },
  {
    listName: "Delivery Of Goods",
    list: [
      {
        item: "Delivery will be made to a location of the buyer's choosing.",
      },
      {
        item: "When goods are delivered to a buyer, confirmation will be requested.",
      },
      {
        item: "Merchant must ensure that the buyer confirms receipt of delivered items on the Pamo platform.",
      },
      {
        item: "Merchants can confirm that delivery has been completed. The buyer's confirmation will initiate the release of the merchant's funds in escrow.",
      },
      {
        item: "If the buyer does not confirm receipt but the merchant confirms the delivery, Pamo will release funds within 48 hours of the merchant's confirmation",
      },
    ],
  },
  {
    listName: "Addition Terms ",
    sub:"Cancellations Returns And Refunds",
    list: [
      {
        item: "Buyers may cancel a deal for the wrong or defective item when a dispute has been raised between the buyer and merchant",
      },
      {
        item: "Buyers may cancel a deal if the item is not delivered by the preferred delivery date as stated in the post.",
      },
      {
        item: "Merchants must confirm or dispute the cancellation claim by the buyer.",
      },
      {
        item: "If a merchant/business confirms the reason for cancellation, it effectively reverses an order. This means funds are automatically returned to the buyer's trade card.",
      },
      {
        item: "If a merchant disputes the reason for cancellation, the dispute will be resolved per the terms in the Pamo Dispute Resolution Procedure.",
      },
      {
        item: "You agree to contract independently on the terms of returns between you and buyers or merchants/businesses as the case may be. Pamo's involvement arises when money paid for an item is held in escrow by Pamo, this is released once delivery is confirmed or a dispute is resolved.",
      },
    ],
  },
  {
    listName: "Force Update Implementation",
    list: [
      {
        item: `Version Requirement : To ensure optimal functionality and security, we require all users to operate the latest version of the App. You acknowledge and agree that certain features or functionalities may be inaccessible if you do not have the most recent version installed. We shall not be liable for your inability to access the app if your device does not support the latest version.
Pamo reserves the right to enforce mandatory updates to the App to maintain compatibility, and security, and enhance user experience standards.`,
      },
      {
        item: `Consent to Updates : By continuing to use the App, you consent to receiving and installing mandatory updates. These updates may include but are not limited to bug fixes, new features, or other enhancements deemed necessary. Your continued use of the App following an update constitutes your acceptance of any modifications made`,
      },
      {
        item: `Update Notifications : The Company shall provide notifications regarding updates via in-app messaging, email, or other appropriate channels. Notifications will outline the nature of the update and any potential impact on your use of the app. In cases where an update is mandatory, you will be given prior notice, unless the update is critical to maintaining the app’s security or functionality. 
Pamo shall not be liable for any losses that arise out of your forfeiture of the app following your refusal to install updates.`,
      },
    ],
  },
  {
    listName: "Limitation Of Liability",
    list: [
      {
        item: "PAMO'S SERVICES ARE OFFERED TO YOU ON AN 'AS IS' OR 'AS AVAILABLE' BASIS. YOU MAKE USE OF THE PAMO SERVICES AT YOUR OWN RISK. AS A RESULT, AS FAR AS PERMITTED BY THE APPLICABLE LAW, PAMO EXCLUDES ALL EXPRESS AND IMPLIED WARRANTIES, TERMS, AND CONDITIONS INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, AND FITNESS FOR PURPOSE TO THE EXTENT PERMITTED BY THE APPLICABLE LAW. UNDER NO CIRCUMSTANCE WILL CONSEQUENTIAL DAMAGES OR LOSSES (INCLUDING, BUT NOT LIMITED TO, LOSS OF MONEY, GOODWILL OR REPUTATION, PROFITS, OTHER INTANGIBLE LOSSES, OR ANY SPECIAL, INDIRECT, OR CONSEQUENTIAL DAMAGES), AND ALL SUCH DAMAGES OR LOSSES ARE EXPRESSLY EXCLUDED BY THIS AGREEMENT WHETHER OR NOT THEY WERE FORESEEABLE OR PAMO WAS ADVISED OF SUCH DAMAGES OR LOSSES. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, WE (INCLUDING OUR PARENT, SUBSIDIARIES, AND AFFILIATES, AND OUR AND THEIR OFFICERS, DIRECTORS, AGENTS, AND EMPLOYEES) ARE NOT LIABLE, AND YOU AGREE NOT TO HOLD US RESPONSIBLE. FOR ANY DAMAGES OR LOSSES (INCLUDING, BUT NOT LIMITED TO, LOSS OF MONEY, GOODWILL OR REPUTATION, PROFITS, OTHER INTANGIBLE LOSSES, OR ANY SPECIAL, INDIRECT, OR CONSEQUENTIAL DAMAGES) RESULTING DIRECTLY OR INDIRECTLY FROM:",
      },
      {
        item: "Your use of or your inability to use our Services ",
      },
      {
        item: "Delays or disruptions in our Services ",
      },
      {
        item: "Viruses or other malicious software obtained by accessing or linking to our Services",
      },
      {
        item: "Glitches, bugs, errors, or inaccuracies of any kind in our Services ",
      },
      {
        item: "Damage to your hardware device from the use of any Pamo Service ",
      },
    ],
  },
  {
    listName: "Ending These Terms",
    list: [
      {
        item: "By You: You may terminate these Terms at any time by deleting your account and stopping your use of the Services.You may delete your account by using the “Delete Account” feature in the App settings.",
      },
      {
        item: "BY PAMO: We may suspend or terminate your Pamo account or stop providing you with access to any or all of our Services at any time, if:",
      },
      {
        item: "(i) - We reasonably suspect that you have violated these Terms, other applicable policies or the instructions provided in our Services.",
      },
      {
        item: "(ii) - You have demonstrated (through your actions or statement or otherwise) that you do not intend to comply with these Terms.",
      },
      {
        item: "(iii) - We decide to end all or part of our Services (either worldwide or in the country where you are resident or from where you access our Services).",
      },
      {
        item: "(iv) - We are required by Applicable Law to end all or part of our Services  (for example, if due to changes in Applicable Law or due to court rulings or judgments which make the Services or parts of them become or be considered unlawful).",
      },
    ],
  },
  {
    listName: "Intellectual Property Rights",
    list: [
      {
        item: "We and/or our content suppliers own the contents and/ or compilation of the contents of the Platform and our Service, including any material, information, data compilations, software, icons, text, graphics, layouts, images, sound clips, advertisements, video clips, digital downloads, trade names, logos, trademarks, designs and service marks ('Our Content') and Our Content is protected by law, including but not limited to intellectual property laws. You do not acquire any right, title, or interest in Our Content. You shall not use, distribute, reproduce, republish, install, transmit, modify, adapt, store, post, copy, screenshot, or record our content without our prior permission unless expressly authorized in these Terms and Conditions or otherwise provided for in law. ",
      },
      {
        item: "You own the information you submit to us as part of your registration, and any data, text, pictures, and other materials that you upload, post, submit, store, send, receive, or share on the Platform or with us ('Your Content'). We do not claim any intellectual property rights of Your Content. Notwithstanding, any provision in these Terms and Conditions and subject to our Privacy Policy you grant us non-exclusive, worldwide, transferable, perpetual, irrevocable right to use, distribute, reproduce, republish, install, transmit, modify, adapt, store, post, copy, display, communicate and retain copies Your Content in connection with the Service, marketing, advertising, and other purposes. You represent and warrant that your use of the Service or any portion thereof, Your Content, and the right you grant us under this clause does not infringe the rights of any person or breach any contract or legal duty owed to any person.",
      },
      {
        item: "Any third-party registered or unregistered intellectual property on the Platform is owned and controlled by that third party and we do not grant any license in respect of the Third-Party Content.Your use of any Third-Party Content is subject to these Terms and Conditions and any terms and conditions of the Third Party.",
      },
      {
        item: "If we have an honest belief that Your Content or part of Your Content infringes our or a third party's intellectual property rights, we shall give you notice of such infringement and remove that content.",
      },
    ],
  },
  {
    listName: "Applicable Law And Jurisdiction",
    list: [
      {
        item: "These Terms and any dispute between you or your affiliates, predecessors, successors, assigns, employees, and agents and us shall be governed by the laws of Ghana irrespective of the rules of conflict of laws.",
      },
      {
        item: "Any dispute arising out of these terms and conditions shall be settled first by direct negotiation. Where negotiation breaks down or the parties are unable to settle the dispute amicably within ninety (90) days, then subject to limitations on the commencement of claims under these Terms, the dispute shall be settled by arbitration per the laws of Ghana and Ghana Arbitration Centre rules.The seat for the arbitration will be in Accra, Ghana. The language for the arbitration shall be English. There shall be a sole arbitrator which shall be appointed by the Ghana Arbitration Centre whose decision shall be final and binding.",
      },
    ],
  },
  {
    listName: "Disputes",
    list: [
      {
        item: "Pamo is under no obligation to become a party to any dispute between Users of our Services. However, based solely on our discretion, Pamo may assist with a mediation process between Users if both parties request and consent to it. The mediation will be carried out in accordance with Pamo’s Dispute Resolution Procedure.",
      },
    ],
  },
  {
    listName: "Miscellaneous Provisions",
    list: [
      {
        item: "These Terms and all terms and policies posted through our Services constitute the entire understanding and agreement between you and Pamo. It supersedes all prior understandings and agreements of the parties.If any provision of these Terms is held by an adjudicatory body of competent jurisdiction to be invalid, the remaining provisions shall remain effective and shall not be affected.",
      },
    ],
  },
  {
    listName: "Amendment",
    list: [
      {
        item: "These Terms are effective as of the date and time it is posted on this page.They shall remain in effect except for any changes in their provisions in the future, which shall be effective immediately after being published.",
      },
      {
        item: "We reserve the right to update or change our Terms. Your continued use of the Service after we post any modifications to these Terms will constitute your acknowledgment of the modifications and your consent to abide by and be bound by the modified Terms.",
      },
    ],
  },
  {
    listName: "Contact",
    list: [
      {
        item: "Phone: +233 59 920 3040",
      },
      {
        item: "Email: info@pamo.app",
      },
      {
        item: "Email: support@pamo.app",
      },
    ],
  },
];
